import { createClient } from '@supabase/supabase-js'

const supabaseUrl: string = process.env.NEXT_PUBLIC_SUPABASE_URL!
const supabaseServerKey: string = process.env.NEXT_PUBLIC_SUPABASE_KEY!

const supabaseClient = createClient(supabaseUrl, supabaseServerKey)

// Export for usage by the rest of the app
export { supabaseClient }
